// extracted by mini-css-extract-plugin
module.exports = {"new-expense":"NewExpenses_new-expense__2Ptwg","alternative":"NewExpenses_alternative__1RG95"};